<template>
<div class="general-back">
<v-layout row wrap fill-height justify-center align-center px-1 class="general-map">
  <v-flex xs12 sm11 md11 lg11>
    <!-- <line-app></line-app> -->
    <div class="cont-titulo text-xs-center my-2">
      <h1>Línea de tiempo</h1>
    </div>
    <div class="container-line">
      <div class="btn-row btn-row-left" @click="rowActionLeft()"><v-icon>navigate_before</v-icon></div>
      <div class="btn-row btn-row-right" @click="rowActionRight()"><v-icon>navigate_next</v-icon></div>
      <div class="cont-slider" id="cont-items"> 
        <div class="cont-items">
          <div class="item" v-for="(item,index) in info.items" :key="'item'+index"
          @click="actionItem(index, item.img)" :class="[{'item-active':selectItem[index]}, 'animated fadeInRight dura-'+index+'']">
            <div class="cont-titulo-item"><h2>{{item.fecha}}</h2></div>
            <div class="cont-img">
              <div class="amarillo" :class="['animated slideOutDown dura-'+index+'']"></div>
              <img :src="'https://static.adaptacioncc.com/images-lineatiempo/'+item.img+'.jpg'" alt="">
            </div>
          </div>
          <div class="line-cont"></div>
        </div>
      </div>
      
      <div class="descripcion animated fadeIn" v-show="modalweb">
        <div class="btn-close" @click="rowActionClose()"><v-icon>close</v-icon></div>
        <h2>{{info.items[numitem].fecha}}</h2>
        <p>{{info.items[numitem].desc}}</p>
      </div>

    </div>
  </v-flex>
  <!-- MODAL -->
  <modal-app v-model="modal" :fullscreen="false" heightCerrar="20px" >
      <template slot="modaltittle">
        <h2 class="modal-titulo">{{info.items[numitem].fecha}}</h2>
      </template>
      <template slot="modalcontent">
        <img class="img-modal" :src="modalimg" alt="">
        <v-divider></v-divider>
        <p class="mt-2">{{info.items[numitem].desc}}</p>
      </template>
  </modal-app>
</v-layout>
</div>
</template>
<script>
import resourcesLoader from "../js/mixins/resources-loader"
export default {
  mixins: [resourcesLoader],
  data() {
    return {
      modal:false,
      modalweb:false,
      modalimg: null,
      ancho:'',
      numitem: 0,
      selectItem:[],
      countitems:'',
      info:[],
    }
  },
  created() {
    this.getJson('lineatiempo', data => {
      this.info = data
    })
    window.addEventListener("resize", this.myEventHandler);
    this.countitems = this.info.length
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },
  methods: {
    myEventHandler(e){
      var $ancho = window.innerWidth
      this.ancho = $ancho
    },
    rowActionRight(){
        var obj = document.getElementById('cont-items')
        obj.scrollLeft = (obj.scrollLeft + 220) || 200
        this.modalweb = false
    },
    rowActionLeft(){
        var obj = document.getElementById('cont-items')
        obj.scrollLeft = (obj.scrollLeft - 220) || 200
        this.modalweb = false
    },
    actionItem(val, valimg){
      this.selectItem = Array(this.countitems).fill(false)
      this.numitem = val
      this.modalweb = false
      this.modal = false
      this.$set(this.selectItem,val,true)
      this.modal = true
      this.modalimg = 'https://static.adaptacioncc.com/images-lineatiempo/'+valimg+'.jpg'
    },
    rowActionClose(){
      this.modalweb = false
    }
  },
}
</script>
<style lang="scss" scoped>
// NOT SCOPED !!
@import '../sass/globals';
@import 'portada';

</style>
